import { useState, useEffect } from 'react';
import { getTaskStatus, ITaskStatus, ITaskSearchParam } from 'wisestep-api';

const useTaskStats = (query: ITaskSearchParam): ITaskStatus => {
  const [taskStats, setTaskStats] = useState<ITaskStatus>();

  useEffect(() => {
    const fetchJobStats = async () => {
      const response = await getTaskStatus(query.searchType);
      const taskStats = response.data;
      setTaskStats(taskStats);
    };

    fetchJobStats();
  }, [query]);

  return taskStats ?? ({} as ITaskStatus);
};

export default useTaskStats;
